var Transform = require('./transform')
var Constants = require('../../constants')

/**
 * This class manages Flow restrictions. All requests shall be blocked until /init or /start are
 * received.
 *
 * @constructs
 * @extends Transform
 * @memberof youbora
 *
 * @param {Plugin} plugin Instance of {@link Plugin}
 */
var FlowTransform = Transform.extend(
  /** @lends FlowTransform.prototype */
  {
    _services: [Constants.Service.INIT, Constants.Service.START],

    /**
     * Returns if transform is blocking.
     *
     * @param {YBRequest} request Request to transform.
     * @return {bool} True if queue shall be blocked.
     */
    isBlocking: function (request) {
      if (this._isBusy && request != null && this._services.indexOf(request.service) !== -1) {
        this.done()
      }

      return Transform.prototype.isBlocking.apply(this, arguments)
    }
  }
)

module.exports = FlowTransform



//////////////////
// WEBPACK FOOTER
// ./src/comm/transform/flow.js
// module id = 25
// module chunks = 0